
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { STPHouseKeepingDeleteAPI, STPHouseKeepingTableDataAPI, STPHouseKeepingTableExportDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPPreventiveWork/STPPreventiveWorkHouseKeepingSlice'
import moment from 'moment'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import { Loading } from '../../../../../../Helper/Loading'
import ViewURL from '../../../../../../Components/ViewURL/ViewURL'
import { TableNote } from '../../../../../../Components/Note/Note'
import { STPPreventiveHouseKeepingExportData } from './STPPreventiveHouseKeepingExportData'
import { TableDeleteNote } from '../../../../../../Components/Note/TableDeleteNote'
import { toastErrorr } from '../../../../../../Helper/ToastMessage'


export default function STPPreventiveHouseKeepingData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails

    const dispatch = useDispatch()

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [STPEquipmentMasterPopupShow, setSTPEquipmentMasterPopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).date(1).format('YYYY-MM-DD'));
    const [FromDate, setFromDate] = useState(date ? moment(date).startOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(date ? date : moment().format('YYYY-MM-DD'))

    // const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    // const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)

    const [Heading, setHeading] = useState('')
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [ShowImagePopup, setshowImagePopup] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [PDF, setPDF] = useState('')


    const handleShowImage = (Imageurl, heading) => {
        setshowImagePopup(true)
        setImagePopUpData(Imageurl)
        setHeading(heading)
    }

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    // const handleAddOnClick = () => {
    //     console.log("add")
    //     setSTPEquipmentMasterPopupShow(true)
    // }

    // const handleEditOnClick = (item) => {
    //     setSTPEquipmentMasterPopupShow(true)
    //     setapiFlag('Update')
    //     setrowData()
    // }

    // const handleOnCloseClick = () => {
    //     setSTPEquipmentMasterPopupShow(false)
    // }
    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })

        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    useEffect(() => {
        const data = {
            M_WardID: WardName.ID,
            FromDate: FromDate,
            ToDate: ToDate,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            Flag: 'Grid',
            handleExport: handleExport
        }
        dispatch(STPHouseKeepingTableDataAPI({ data }))
    }, [IsPost, To, isSearch, IsClear])
    const { tableData, isLoading } = useSelector(state => state.STPHouseKeepingTableData)

    const handleExport = () => {
        const data = {
            M_WardID: WardName.ID,
            FromDate: FromDate,
            ToDate: ToDate,
            M_UserID: UserID,
            token: token,
            From: '1',
            To: '99999',
            Flag: 'Report',
            setPDF: setPDF
        }
        dispatch(STPHouseKeepingTableExportDataAPI({ data }))
    }
    // [IsPost, isSearch, IsClear]
    const { ExportTableData, isExportLoading } = useSelector(state => state.STPHouseKeepingTableExportData)

    const handleGetPDF = () => {
        if (PDF && PDF != '') {
            window.open(PDF)
        } else {
            toastErrorr("PDF not found")
        }
    }

    const handleDeleteApi = (item) => {
        const data = {
            T_STP_HouseKeppingID: item.t_stP_HouseKeppingID,
            M_UserID: UserID,
            token: token,
            Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(STPHouseKeepingDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.PumpingOperationDelete)


    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId} />
                <div className="content">

                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>House Keeping</h5>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :

                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <>
                                                <STPPreventiveHouseKeepingExportData
                                                    ExcelData={ExportTableData}
                                                    name='House Keeping'
                                                    FromDate={FromDate}
                                                    ToDate={ToDate}
                                                // searchName={searchName}
                                                />

                                                <button type="button"
                                                    className="btn btn-danger float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                                                    //  className="btn btn-outline-danger float-end mr-1 mb-2 px-1"
                                                    onClick={handleGetPDF}
                                                ><i className='fas fa-file-pdf mx-1'></i>PDF</button>
                                            </>

                                    }

                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12 mb-5">

                                        <div className="row py-1 rounded2">

                                            <div className="col-lg-2 col-md-6">
                                                <label for=""><b>From Date </b></label>
                                                <input type="date"
                                                    className="form-control"
                                                    id="FromDate"
                                                    value={FromDate}
                                                    onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                />

                                            </div>

                                            <div className="col-lg-2 col-md-6">
                                                <label for=""><b>To Date </b></label>
                                                <input type="date"
                                                    className="form-control"
                                                    id="ToDate"
                                                    value={ToDate}
                                                    onChange={(e) => setToDate(e.target.value)}
                                                    min={FromDate}
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-6">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive">
                                            <TableDeleteNote />
                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Reading Date</th>
                                                        <th>Particular</th>
                                                        <th>Status</th>
                                                        <th>Photo</th>
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td>{item.readingDate ? item.readingDate : '-'}</td>
                                                                <td>{item.houseKeepingType ? item.houseKeepingType : '-'}</td>
                                                                <td>{item.indicatorName ? item.indicatorName : '-'}</td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    {
                                                                        (item.photo == null) ?
                                                                            <span>-</span>
                                                                            :
                                                                            <>
                                                                                <i className="fa-solid fa-eye" title='View'
                                                                                    style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                    onClick={() => handleShowImage(item.photo, 'Photo')}
                                                                                ></i>
                                                                            </>
                                                                    }
                                                                </td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    {
                                                                        ((item.readingDate) == moment().format('DD/MM/YYYY')) ?
                                                                            <DeletePopup
                                                                                open={DeletePopupShow}
                                                                                handleDeleteApi={handleDeleteApi}
                                                                                item={item}
                                                                            />
                                                                            :
                                                                            '-'
                                                                    }

                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            {
                ShowImagePopup &&
                <ViewURL
                    Heading={Heading}
                    ImagePopUpData={ImagePopUpData}
                    setshowImagePopup={setshowImagePopup}
                />
            }
        </div>

    )
}